import React from 'react';

const FaCircleStoreIcon = ({
  backgroundColor = process.env.REACT_APP_KEYCLOAK_CLIENT_ID === 'financeiro-front' ? '#171b54' : '#3DA4BC',
  color = '#fff',
  size = 30,
}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 19 19">
    <g id="Grupo_1749" data-name="Grupo 1749" transform="translate(-665 -16)">
      <g id="Elipse_6" data-name="Elipse 6" transform="translate(665 16)" fill={color} stroke={color} strokeWidth="1">
        <circle cx="9.5" cy="9.5" r="9.5" stroke="none" />
        <circle cx="9.5" cy="9.5" r="9" fill="none" />
      </g>
      <path
        id="Icon_awesome-store"
        data-name="Icon awesome-store"
        d="M12.474,2.457,11.13.311A.663.663,0,0,0,10.568,0H2.2a.663.663,0,0,0-.561.311L.293,2.457A1.848,1.848,0,0,0,1.511,5.283a2.153,2.153,0,0,0,.284.019,2.046,2.046,0,0,0,1.529-.686,2.047,2.047,0,0,0,3.058,0,2.047,2.047,0,0,0,3.058,0,2.052,2.052,0,0,0,1.529.686,2.13,2.13,0,0,0,.284-.019A1.846,1.846,0,0,0,12.474,2.457Zm-1.5,3.509a2.628,2.628,0,0,1-.611-.079V7.955H2.406V5.888a2.744,2.744,0,0,1-.611.079,2.8,2.8,0,0,1-.373-.025,2.605,2.605,0,0,1-.34-.075V9.944a.662.662,0,0,0,.663.663h9.281a.662.662,0,0,0,.663-.663V5.867a2.115,2.115,0,0,1-.34.075A2.881,2.881,0,0,1,10.972,5.966Z"
        transform="translate(668.117 20.196)"
        fill={backgroundColor}
      />
    </g>
  </svg>
);

export default FaCircleStoreIcon;
